<template>
        <b-btn data-test-path="header-gallery-button" @click="openGallery"
               variant="plm-toolbar-secondary" class="m-1" style="width: 42px">
          <font-awesome-icon icon="images" />
        </b-btn>
</template>

<script>


import ActivityManager from "@/activity/ActivityManager";
import ImageGallery from "@/server/com/silkplm/files/images/ImageGallery";
import FormValidatedField from "@/components/forms/FormValidatedField";
const ImageGalleryCard = () => require("@/components/img/ImageGalleryCard");

export default {
  name: "GalleryButton",

  mounted() {
    this.loadGallery()
  },

  props: {
    form: {default: null},
    validatedField: {type: FormValidatedField, required: true},
  },

  methods: {
    async loadGallery() {
      if (this.validatedField && this.validatedField.value && this.validatedField.value.imagesList) {
        this.localImagesList = [...this.validatedField.value.imagesList];
      } else {
        this.localImagesList = [];
      }
    },

    async openGallery(){
      let entityId = this.validatedField.validatedForm?.originalSource?.id;

      if (this.localImagesList != null && this.localImagesList.length > 0) {
        this.localImagesList.sort((a, b) => a.data.name.toLowerCase() > b.data.name.toLowerCase() ? 1 : -1);
        this.listOfImagesInGalleryCard = this.localImagesList;

          for(let image of this.listOfImagesInGalleryCard) {
            image.starState = "star-outline"
            if (image.customData) {
              if (image.customData.imageTagList.find(tag => tag.name === "Main Picture")) {
                image.starState = "star"
              }
            }
          }

      } else {
        this.listOfImagesInGalleryCard = [];
      }

      let imageGalleryCard = await ActivityManager.showActivity(ImageGalleryCard, {
        numberOfUnsavedImages: this.numberOfUnsavedImages,
        listOfImagesInGalleryCard: this.listOfImagesInGalleryCard,
        originalListOfImages: this.localImagesList,
        formConfig: this.form.formConfig
      });

      imageGalleryCard.$on("save", async () => {
        let imageGalleryCardResult = await imageGalleryCard.getResult();
        if (imageGalleryCardResult) {
          this.localImagesList = imageGalleryCardResult.listOfImagesInGalleryCard;
          this.numberOfImages = this.localImagesList.length;
          this.numberOfUnsavedImages = imageGalleryCardResult.numberOfUnsavedImages;
          if (this.validatedField.value == null) {
            this.validatedField.value = new ImageGallery();
          }
          // // to przypisanie musi koniecznie wywołać setter, tak by wywołała się w tle walidacja wykonana w setterze
          let gallery = this.validatedField.value;
          gallery.imagesList = this.localImagesList;
          this.validatedField.value = gallery;
          if (entityId) {
            await this.validatedField.saveField();
          }
        }
        let result = {
          "numberOfImages": this.numberOfImages,
          "imagesList": this.localImagesList,
          "listOfImagesInGalleryCard": this.localImagesList,
        }
        this.$emit('updateGalleryRenderer', result);
      });
    },
  },
  watch: {
    'validatedField': function (val) {
      this.loadGallery();
    },
    'validatedField.value': function (val) {
      this.loadGallery();
    },
  },
  data: () => ({
    localImagesList: null,
    numberOfUnsavedImages: 0,
    listOfImagesInGalleryCard: null,
  })
}
</script>
